import UIKitImage1 from "./uiKit1.png";
import UIKitImage2 from "./uiKit2.png";

export const UIKitImage = [UIKitImage1, UIKitImage2];

// export { default as UIKitImage } from "./uiKit0.png";
